"use strict";
/**
 * Static layout / API constants for the Use Case Details page.
 *
 * Kept separate from the orchestrator component so changes to copy and
 * tuning values do not force the (large) `UseCaseDetails.tsx` to be
 * re-read.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.clampMultiColumnPaneHeight = exports.MULTI_COLUMN_PANE_VERTICAL_OFFSET = exports.MIN_MULTI_COLUMN_PANE_HEIGHT = exports.DEFAULT_OUTPUT_LOADING_LABEL = exports.AZURE_DEVOPS_PROJECT = exports.AZURE_DEVOPS_ORGANISATION = exports.DEFAULT_FONT_SCALE_BY_COLUMN_COUNT = exports.FONT_SCALE_OPTIONS = exports.UCA_ACTIONS_TOOLTIP_TEXT = void 0;
exports.UCA_ACTIONS_TOOLTIP_TEXT = 'Optimise runs the UCA optimisation of the use case. Start Analysis starts the full UCA analysis which generates the reports. Sync Analysis pulls the reports back into ADO.';
exports.FONT_SCALE_OPTIONS = [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150];
exports.DEFAULT_FONT_SCALE_BY_COLUMN_COUNT = {
    1: 100,
    2: 90,
    3: 80,
};
exports.AZURE_DEVOPS_ORGANISATION = 'AVA-WorkplaceServices';
exports.AZURE_DEVOPS_PROJECT = 'AI Hub';
exports.DEFAULT_OUTPUT_LOADING_LABEL = 'Loading use case output...';
exports.MIN_MULTI_COLUMN_PANE_HEIGHT = 320;
exports.MULTI_COLUMN_PANE_VERTICAL_OFFSET = 220;
exports.clampMultiColumnPaneHeight = function (nextHeight) {
    return Math.max(exports.MIN_MULTI_COLUMN_PANE_HEIGHT, nextHeight);
};
